import { SPORTS } from '../data/constants';
import { BodyDiagram } from './AddRecord';
import { shareOrDownloadCanvas } from '../utils/shareCanvas';

function formatDuration(min) {
    const total = +min || 0;
    const h = Math.floor(total / 60);
    const m = total % 60;
    if (h && m) return `${h}시간 ${m}분`;
    if (h) return `${h}시간`;
    return `${m}분`;
}

function downloadShareImage(r) {
    const sp = SPORTS[r.sport];
    const canvas = document.createElement('canvas');
    canvas.width = 1080;
    canvas.height = 1350;
    const ctx = canvas.getContext('2d');
    const accent = sp?.color || '#c8f764';

    const roundRect = (x, y, w, h, radius) => {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.arcTo(x + w, y, x + w, y + h, radius);
        ctx.arcTo(x + w, y + h, x, y + h, radius);
        ctx.arcTo(x, y + h, x, y, radius);
        ctx.arcTo(x, y, x + w, y, radius);
        ctx.closePath();
    };
    const text = (value, x, y, size, color = '#f4f4f4', weight = 500, align = 'left') => {
        ctx.fillStyle = color;
        ctx.font = `${weight} ${size}px "DM Sans", "Apple SD Gothic Neo", sans-serif`;
        ctx.textAlign = align;
        ctx.fillText(value, x, y);
    };
    const wrapText = (value, x, y, maxWidth, lineHeight, size, color = '#f4f4f4', weight = 500, maxLines = 4) => {
        ctx.fillStyle = color;
        ctx.font = `${weight} ${size}px "DM Sans", "Apple SD Gothic Neo", sans-serif`;
        const words = String(value || '').split(' ');
        const lines = [];
        let line = '';
        words.forEach(word => {
            const test = line ? `${line} ${word}` : word;
            if (ctx.measureText(test).width > maxWidth && line) {
                lines.push(line);
                line = word;
            } else {
                line = test;
            }
        });
        if (line) lines.push(line);
        lines.slice(0, maxLines).forEach((l, i) => ctx.fillText(l, x, y + i * lineHeight));
    };
    const techniqueLines = Array.isArray(r.techniques)
        ? r.techniques
            .filter(t => t.name || t.position)
            .map(t => [t.name, t.result && `[${t.result}]`, t.position && `(${t.position})`, t.category && `[${t.category}]`].filter(Boolean).join(' '))
        : [];
    const exerciseLines = (r.exercises || [])
        .filter(ex => ex.name || ex.sets?.length)
        .map(ex => {
            const sets = (ex.sets || [])
                .filter(s => s.reps || s.weight)
                .map((s, i) => `${i + 1}.${s.reps || 0}x${s.weight || 0}kg`)
                .join(' ');
            return [ex.name, ex.muscleGroup && `(${ex.muscleGroup})`, sets].filter(Boolean).join(' ');
        });

    ctx.fillStyle = '#0f0f0f';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const gradient = ctx.createRadialGradient(850, 160, 40, 850, 160, 620);
    gradient.addColorStop(0, `${accent}66`);
    gradient.addColorStop(1, 'rgba(15,15,15,0)');
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    wrapText(sp?.name || r.sport, 80, 170, 900, 92, 86, '#f4f4f4', 700, 2);
    text(r.date, 82, 232, 30, '#777', 400);
    text(formatDuration(r.duration), 82, 345, 48, accent, 700);
    if (r.focus) text(r.focus.slice(0, 34), 82, 405, 34, '#f4f4f4', 500);

    const statItems = [
        ['컨디션', `${r.condScore || 3}/5`],
        ['운동강도', `${r.fatScore || 3}/5`],
    ];
    if (r.buddies?.length) statItems.push(['함께', `${r.buddies.length}명`]);
    if (r.sparring) statItems.push(['스파링', `${r.sparringRounds || 0}R`]);

    const statBoxY = 500;
    const statRowHeight = 150;
    const statRows = Math.ceil(statItems.length / 2);
    const statBoxHeight = 145 + statRows * statRowHeight;
    const contentY = statBoxY + statBoxHeight + 82;

    roundRect(80, statBoxY, 920, statBoxHeight, 34);
    ctx.fillStyle = '#181818';
    ctx.fill();
    ctx.strokeStyle = '#333';
    ctx.lineWidth = 2;
    ctx.stroke();

    statItems.forEach((item, i) => {
        const x = 130 + (i % 2) * 430;
        const y = statBoxY + 100 + Math.floor(i / 2) * statRowHeight;
        text(item[0], x, y, 28, '#777', 400);
        text(item[1], x, y + 66, 58, '#f4f4f4', 700);
    });

    if (exerciseLines.length) {
        text('WORKOUT', 82, contentY, 24, '#777', 500);
        exerciseLines.slice(0, 5).forEach((line, i) => {
            wrapText(line, 82, contentY + 58 + i * 52, 880, 38, 30, '#f4f4f4', 500, 1);
        });
    } else if (techniqueLines.length) {
        text('TECHNIQUE / DRILL', 82, contentY, 24, '#777', 500);
        techniqueLines.slice(0, 4).forEach((line, i) => {
            wrapText(line, 82, contentY + 58 + i * 58, 880, 38, 30, '#f4f4f4', 500, 1);
        });
    } else if (r.cardioType || r.distance || r.calories) {
        text('CARDIO', 82, contentY, 24, '#777', 500);
        const cardio = [r.cardioType, r.distance && `${r.distance}km`, r.calories && `${r.calories}kcal`].filter(Boolean).join(' · ');
        wrapText(cardio, 82, contentY + 58, 880, 44, 36, '#f4f4f4', 500, 2);
    }
    if (r.buddies?.length) {
        text(`WITH ${r.buddies.map(b => b.nickname).join(', ').slice(0, 42)}`, 82, 1232, 26, '#999', 500);
    }
    text('WORKOUT JOURNAL', 82, 1270, 26, accent, 700);

    shareOrDownloadCanvas(
        canvas,
        `workout-share-${r.date}.png`,
        `${sp?.name || r.sport} 운동 기록`,
        `${sp?.name || r.sport} 완료했어요!`
    );
}

const RESULT_COLORS = {
    '성공': { bg: '#4caf5020', color: '#4caf50' },
    '시도': { bg: 'var(--bg3)', color: 'var(--text3)' },
    '당함': { bg: '#ff7c5c20', color: '#ff7c5c' },
};

const SPARRING_RESULT_COLORS = {
    '승': '#4caf50',
    '패': '#ff7c5c',
    '무': 'var(--text3)',
};

const isBjjSport = sport => ['gi_bjj', 'nogi_bjj', 'bjj'].includes(sport);
const sparringMetricLabel = (sport, category) => {
    if (isBjjSport(sport)) return '탭';
    if (category === 'grappling') return '테이크다운/한판';
    if (category === 'striking') return '다운';
    return '피니시/KD';
};

export default function RecordDetail({ record: r, onBack, onEdit, onCreateRoutine, onDelete }) {
    const sp = SPORTS[r.sport];
    const category = sp?.category || r.sport;
    const isGrappling = category === 'grappling';
    const isStriking = category === 'striking';
    const isCombat = ['grappling', 'striking', 'combat'].includes(category);

    const activeTechniques = Array.isArray(r.techniques)
        ? r.techniques.filter(t => t.name || t.point)
        : [];

    return (
        <>
            <button className="back-btn" onClick={onBack}>← 돌아가기</button>

            <div className="detail-panel">
                <div className="detail-head">
                    <div className="sport-dot" style={{ background: sp?.color || '#888' }} />
                    {sp?.name || r.sport} · {r.date}
                </div>
                {r.duration && <div className="detail-row"><span className="detail-key">운동 시간</span><span className="detail-val">{formatDuration(r.duration)}</span></div>}
                {r.focus && <div className="detail-row"><span className="detail-key">운동 목표</span><span className="detail-val">{r.focus}</span></div>}
                {r.buddies?.length > 0 && (
                    <div className="detail-row"><span className="detail-key">함께 운동</span><span className="detail-val">{r.buddies.map(b => b.nickname).join(', ')}</span></div>
                )}
                {r.sport === 'bjj' && r.gi && <div className="detail-row"><span className="detail-key">그래플링 종목</span><span className="detail-val">{r.gi}</span></div>}
                {r.sport === 'striking' && r.strType && <div className="detail-row"><span className="detail-key">타격 종목</span><span className="detail-val">{r.strType}</span></div>}
                {category === 'cardio' && r.cardioType && <div className="detail-row"><span className="detail-key">유산소 종목</span><span className="detail-val">{r.cardioType}</span></div>}

                {/* 그래플링 드릴 시간 */}
                {isGrappling && r.drillTime && (
                    <div className="detail-row"><span className="detail-key">드릴 시간</span><span className="detail-val">{r.drillTime}분</span></div>
                )}

                {/* 타격/MMA 훈련 구성 */}
                {(isStriking || category === 'combat') && r.strikingDrills?.filter(d => d.type || d.minutes).length > 0 && (
                    <div className="detail-row">
                        <span className="detail-key">훈련 구성</span>
                        <span className="detail-val">{r.strikingDrills.filter(d => d.type || d.minutes).map(d => [d.type, d.minutes && `${d.minutes}분`].filter(Boolean).join(' ')).join(' · ')}</span>
                    </div>
                )}

                {/* 스파링 */}
                {r.sparring && (
                    <div className="detail-row">
                        <span className="detail-key">스파링</span>
                        <span className="detail-val">{[r.sparringRounds && `${r.sparringRounds}회`, r.sparringMin && `총 ${r.sparringMin}분`].filter(Boolean).join(' · ') || '했음'}</span>
                    </div>
                )}
                {r.sparringPartner && <div className="detail-row"><span className="detail-key">스파링 상대</span><span className="detail-val">{r.sparringPartner}</span></div>}

                {/* 라운드별 기록 */}
                {isCombat && r.sparringRoundsList?.filter(rd => rd.result || rd.opponentLevel || rd.notes || rd.tapouts || rd.opponent || rd.roundCount || rd.roundMinutes).length > 0 && (
                    <div className="detail-row" style={{ alignItems: 'flex-start' }}>
                        <span className="detail-key">스파링별</span>
                        <span className="detail-val" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                            {r.sparringRoundsList.filter(rd => rd.result || rd.opponentLevel || rd.notes || rd.tapouts || rd.opponent || rd.roundCount || rd.roundMinutes).map((rd, i) => (
                                <span key={i} style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap' }}>
                                        <strong>스파링 {i + 1}</strong>
                                        {(rd.roundCount || rd.roundMinutes) && (
                                            <span style={{ fontSize: 11, color: 'var(--text3)' }}>
                                                {[rd.roundCount && `${rd.roundCount}R`, rd.roundMinutes && `${rd.roundMinutes}분`].filter(Boolean).join(' · ')}
                                            </span>
                                        )}
                                        {rd.result && (
                                            <span style={{ fontSize: 12, fontWeight: 700, color: SPARRING_RESULT_COLORS[rd.result] || 'var(--text2)' }}>{rd.result}</span>
                                        )}
                                        {rd.opponent && (
                                            <span style={{ fontSize: 12, color: 'var(--text1)' }}>
                                                {rd.opponent.uid && <span style={{ fontSize: 10, color: 'var(--accent)', marginRight: 2 }}>@</span>}
                                                {rd.opponent.nickname || rd.opponent.name}
                                            </span>
                                        )}
                                        {rd.opponentLevel && <span style={{ fontSize: 11, color: 'var(--text3)' }}>({rd.opponentLevel})</span>}
                                        {rd.tapouts && <span style={{ fontSize: 11, color: 'var(--text3)' }}>{sparringMetricLabel(r.sport, category)} {rd.tapouts}회</span>}
                                    </span>
                                    {rd.notes && <span style={{ color: 'var(--text2)', fontSize: 12, whiteSpace: 'pre-wrap' }}>{rd.notes}</span>}
                                </span>
                            ))}
                        </span>
                    </div>
                )}

                {/* 기술 */}
                {activeTechniques.length > 0 && (
                    <div className="detail-row" style={{ alignItems: 'flex-start', flexDirection: 'column' }}>
                        <span className="detail-key" style={{ marginBottom: '10px' }}>배운 기술</span>
                        <span className="detail-val" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                            {activeTechniques.map((t, i) => (
                                <span style={{ marginBottom: '20px' }} key={i}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', marginBottom: t.point ? 3 : 0 }}>
                                        {t.name && <strong>{t.name}</strong>}
                                    </span>
                                    <p style={{ marginBottom: '10px' }}>
                                        {t.result && (
                                            <span style={{
                                                fontSize: 10, borderRadius: 4, padding: '1px 6px',
                                                background: RESULT_COLORS[t.result]?.bg || 'var(--bg3)',
                                                color: RESULT_COLORS[t.result]?.color || 'var(--text3)',
                                            }}>{t.result}</span>
                                        )}
                                        {t.position && <span style={{ fontSize: 11, color: 'var(--text3)' }}>({t.position})</span>}
                                        {t.category && <span style={{ fontSize: 11, color: 'var(--text3)' }}>[{t.category}]</span>}
                                    </p>
                                    <span>
                                        {t.point && <span style={{ color: 'var(--text2)', fontSize: 13, whiteSpace: 'pre-wrap' }}>{t.point}</span>}
                                    </span>
                                </span>
                            ))}
                        </span>
                    </div>
                )}

                {/* 기존 단일 string techniques 하위호환 */}
                {r.techniques && !Array.isArray(r.techniques) && (
                    <div className="detail-row"><span className="detail-key">배운 기술</span><span className="detail-val">{r.techniques}</span></div>
                )}

                {/* 웨이트 운동 */}
                {r.exercises?.length > 0 ? (
                    <>
                        <div className="detail-row" style={{ alignItems: 'flex-start' }}>
                            <span className="detail-key">운동</span>
                            <span className="detail-val" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                                {r.exercises.map((ex, i) => (
                                    <span key={i}>
                                        <strong>{ex.name}</strong>
                                        {ex.muscleGroup && <span style={{ fontSize: 11, color: 'var(--text3)', marginLeft: 6 }}>({ex.muscleGroup})</span>}
                                        {ex.sets?.length > 0 && (
                                            <><br /><span style={{ color: 'var(--text2)' }}>{ex.sets.map((s, j) => `${j + 1}. ${s.reps}회×${s.weight}kg`).join(' / ')}</span></>
                                        )}
                                    </span>
                                ))}
                            </span>
                        </div>
                        {(r.muscleGroups?.length > 0 || r.exercises.some(ex => ex.muscleGroup)) && (
                            <BodyDiagram muscles={r.muscleGroups || r.exercises.map(ex => ex.muscleGroup).filter(Boolean)} />
                        )}
                    </>
                ) : (
                    <>
                        {r.exerciseName && <div className="detail-row"><span className="detail-key">운동명</span><span className="detail-val">{r.exerciseName}</span></div>}
                        {r.sets?.length > 0 && (
                            <div className="detail-row">
                                <span className="detail-key">세트</span>
                                <span className="detail-val">{r.sets.map((s, i) => `${i + 1}. ${s.reps}회×${s.weight}kg`).join(' / ')}</span>
                            </div>
                        )}
                    </>
                )}

                {/* 유산소 */}
                {r.distance && <div className="detail-row"><span className="detail-key">거리</span><span className="detail-val">{r.distance}km</span></div>}
                {r.calories && <div className="detail-row"><span className="detail-key">칼로리</span><span className="detail-val">{r.calories}kcal</span></div>}
                {r.avgHR && <div className="detail-row"><span className="detail-key">평균 심박수</span><span className="detail-val">{r.avgHR} bpm</span></div>}
                {r.pace && <div className="detail-row"><span className="detail-key">페이스</span><span className="detail-val">{r.pace} /km</span></div>}
                {r.power && <div className="detail-row"><span className="detail-key">평균 파워</span><span className="detail-val">{r.power} W</span></div>}
                {r.strokeRate && <div className="detail-row"><span className="detail-key">스트로크</span><span className="detail-val">{r.strokeRate} SPM</span></div>}
                {(r.intervalWork || r.intervalSets) && (
                    <div className="detail-row">
                        <span className="detail-key">인터벌</span>
                        <span className="detail-val">
                            {[r.intervalWork && `${r.intervalWork}초`, r.intervalSets && `× ${r.intervalSets}세트`, r.intervalRest && `휴식 ${r.intervalRest}초`].filter(Boolean).join(' ')}
                        </span>
                    </div>
                )}

                <div className="detail-row"><span className="detail-key">컨디션</span><span className="detail-val">{r.condScore || 3}/5</span></div>
                <div className="detail-row"><span className="detail-key">운동강도</span><span className="detail-val">{r.fatScore || 3}/5</span></div>
                {r.diary && <div className="diary-text">{r.diary}</div>}
            </div>

            <div className="action-row">
                <button className="action-btn" onClick={onEdit}>수정하기</button>
                <button className="action-btn" onClick={() => downloadShareImage(r)}>공유하기</button>
                <button className="action-btn" onClick={onCreateRoutine}>루틴 생성</button>
                <button className="action-btn danger" onClick={onDelete}>삭제</button>
            </div>
        </>
    );
}
